import { render, staticRenderFns } from "./pagina-inicial.vue?vue&type=template&id=f05ab526&scoped=true&"
import script from "./pagina-inicial.vue?vue&type=script&lang=ts&"
export * from "./pagina-inicial.vue?vue&type=script&lang=ts&"
import style0 from "./pagina-inicial.vue?vue&type=style&index=0&id=f05ab526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ab526",
  null
  
)

export default component.exports